import { render, staticRenderFns } from "./Candu.vue?vue&type=template&id=66d7510e&scoped=true&"
import script from "./Candu.vue?vue&type=script&lang=js&"
export * from "./Candu.vue?vue&type=script&lang=js&"
import style0 from "./Candu.vue?vue&type=style&index=0&id=66d7510e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d7510e",
  null
  
)

export default component.exports